import React from 'react';
import SeoWrapper from '../components/SeoWrapper';
import About from '../components/About';
import Technologies from '../components/Technologies';
import Projects from '../components/Projects';
import Contact from '../components/Contact';
import content from '../data/content.json';

const Home = ({ language, years }) => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "Person",
    "name": "Kamil Priefer",
    "url": "https://priefer.pl",
    "jobTitle": "Full Stack Developer & IT Specialist",
    "description": language === 'pl' ? content.about.description_pl : content.about.description_en,
    "image": "https://priefer.pl/logo512.png",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Poznań",
      "addressCountry": "PL"
    },
    "email": content.contact.email,
    "telephone": content.contact.phone,
    "worksFor": {
      "@type": "Organization",
      "name": "Freelance"
    },
    "sameAs": [
      content.contact.linkedin,
      content.contact.github
    ]
  };

  return (
    <>
      <SeoWrapper
        title={language === 'pl' ? "Strona Główna" : "Home"}
        description={language === 'pl' ? content.about.description_pl : content.about.description_en}
        url="/"
        schema={schema}
        keywords="Informatyk Poznań, Programista Freelancer, Strony WWW Poznań, Obsługa IT, Kamil Priefer, Full Stack Developer"
      />
      <About about={content.about} years={years} language={language} contact={content.contact} />
      <Technologies technologies={content.technologies} language={language} />
      <Projects projects={content.projects} language={language} limit={3} />
      <Contact contact={content.contact} language={language} />
    </>
  );
};

export default Home;
